import React from 'react';
import {MetricsElement} from 'react-metrics';

import { Helpers } from '../../core/src/helpers';
import ProductPrice from '../../product/components/product-price';
import ProductPriceV2 from '../../product/components/product-price/product-price-v2';
import ImageWithPlaceholder from '../../shared/components/image-with-placeholder';
import Link from '../../shared/components/hyperlink';
import Checkbox from "../../ui/components/checkbox";

import '../css/xsell-modal.less';
import '../css/xsell-product-v2.less';

const XSellProductItem = ({isV2, product, addProduct, removeProduct, priceObj, addedProducts, disableRemove, twoUpVersion, className, setCarouselHeight = null, productClickMetrics}) => {
	const imageSrc = Helpers.getCDNUrl(product.images[0].cdn, product.images[0].lrg);
	let selected = !!addedProducts.find(addedProd => addedProd.sku === product.sku);

    
    const handleInputChange = ()=>{
        if(!selected){
            addProduct(product);
        }else{
            removeProduct(product);
        }
    }

    const checkAvailability = ()=>{
        if(priceObj === undefined){
            return;
        }
        if(priceObj.stock === undefined || (priceObj.stock > 0)){
            return isV2 ? ( 
            <Checkbox checked={selected} size={24} onClick={disableRemove ? () => void 0 : handleInputChange}>
                {selected ? 'Added to cart' : 'Add to cart'}
            </Checkbox>
            ) : (
            <div className='checkbox' onClick={disableRemove ? () => void 0 : handleInputChange}>
                <span className={`add-checkbox${selected ? ' checkbox-selected' : ''}`}></span>
                <span className={`view-compare${disableRemove ? ' disable-remove': ''}`}>{`${twoUpVersion !== 'original' && twoUpVersion !== '' ? 'Added' : 'Add'} to Cart`}</span>
            </div>
            )
        }else{
            return <label className='checkbox-label'>Out of stock</label>
        }
    }

    let hasProductClickMetrics = productClickMetrics && typeof productClickMetrics === 'object';
    const productLink = (
        <Link {...hasProductClickMetrics ? productClickMetrics : {}} className="xsell-item-header" to={product.linkUrl} target='_blank' title={product.name}>
            <h3>
                {product.name}
            </h3>
        </Link>
    );


	return(
		<div className={`xsell-product${isV2 ? ' v2' : ''}`}>
			<ImageWithPlaceholder className='xsell-image-item' src={imageSrc} alt={product.name} onLoad={()=>setCarouselHeight}/>
			<div className='xsell-product-body'>
				{
                    hasProductClickMetrics
                    ? <MetricsElement>{productLink}</MetricsElement>
                    : productLink
                }
				<div className='xsell-item-info'>
					{ isV2 ? <ProductPriceV2 product={product} className='xsell-prod-price' /> : <ProductPrice product={product}/> }
					{checkAvailability()}
				</div>
			</div>
		</div>
	)
}

export default XSellProductItem;
